import { jsx as _jsx } from "react/jsx-runtime";
import { HcDropdownHeader } from '@hotmart-org-ca/cosmos-web/dist/react/hc-dropdown';
export function DropdownHeader({ title, className, onClick, slot = 'items' }) {
    return (_jsx(HcDropdownHeader, { slot: slot, className: className, onClick: onClick, role: "button", children: title && _jsx("div", { slot: "label", children: title }) }));
}
